var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"update"},[_vm._v("系统升级中... 全新亮相，敬请期待!")])}
var staticRenderFns = []

export { render, staticRenderFns }